import { render, staticRenderFns } from "./newsCenter.vue?vue&type=template&id=64596dd6&scoped=true"
import script from "./newsCenter.vue?vue&type=script&lang=js"
export * from "./newsCenter.vue?vue&type=script&lang=js"
import style0 from "./newsCenter.vue?vue&type=style&index=0&id=64596dd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64596dd6",
  null
  
)

export default component.exports